module.exports = __webpack_public_path__ + "static/media/ic_badge_silver.4b6c1143.png";